import { getCheckinAntecedence } from './getCheckinAntecedence';
import { getComparatorBanner } from './getComparatorBanner';
import { getComparatorPage } from './getComparatorPage';
import { getComparatorShowcase } from './getComparatorShowcase';
import { getPoweredBy } from './getPoweredBy';
import { getShowcases } from './getShowcases';
import { getShowMilesFirst } from './getShowMilesFirst';

export const ProductConfigServices = {
  getCheckinAntecedence,
  getComparatorBanner,
  getComparatorPage,
  getComparatorShowcase,
  getPoweredBy,
  getShowcases,
  getShowMilesFirst,
};
